(() => {
  if (!customElements.get('footer-menu')) {
    class FooterMenu extends HTMLElement {
      constructor() {
        super();
        this.onMediaChange = this.onMediaChange.bind(this);
      }

      connectedCallback() {
        this.details = this.querySelector('[data-menu]');
        if (!this.details) return;
        this.defaultOpen = this.hasAttribute('data-default-open');
        this.media = window.matchMedia('(min-width: 960px)');
        this.media.addEventListener('change', this.onMediaChange);
        this.onMediaChange(this.media);
      }

      disconnectedCallback() {
        this.media?.removeEventListener('change', this.onMediaChange);
      }

      // Desktop renders the menu as a static column, so the accordion is forced open there.
      onMediaChange(event) {
        this.details.open = event.matches ? true : this.defaultOpen;
      }
    }

    customElements.define('footer-menu', FooterMenu);
  }

  if (!customElements.get('footer-panel')) {
    class FooterPanel extends HTMLElement {
      constructor() {
        super();
        this.onIntersect = this.onIntersect.bind(this);
        this.onConsentInvalid = this.onConsentInvalid.bind(this);
        this.onConsentChange = this.onConsentChange.bind(this);
      }

      connectedCallback() {
        this.consent = this.querySelector('[data-consent]');
        this.consent?.addEventListener('invalid', this.onConsentInvalid);
        this.consent?.addEventListener('change', this.onConsentChange);

        if (!this.hasAttribute('data-animate')) return;
        this.revealGroup = this.querySelector('[data-reveal-group]');
        this.revealItems = [...this.querySelectorAll('[data-reveal]')];
        if (!this.revealGroup || !this.revealItems.length) return;
        this.observer = new IntersectionObserver(this.onIntersect, { threshold: 0 });
        this.observer.observe(this.revealGroup);
      }

      disconnectedCallback() {
        this.consent?.removeEventListener('invalid', this.onConsentInvalid);
        this.consent?.removeEventListener('change', this.onConsentChange);
        this.observer?.disconnect();
      }

      onIntersect(entries) {
        if (!entries[0].isIntersecting) return;
        this.observer.disconnect();
        this.revealItems.forEach((item) => item.classList.add('is-revealed'));
      }

      onConsentInvalid() {
        this.consent.classList.add('is-invalid');
      }

      onConsentChange() {
        this.consent.classList.remove('is-invalid');
      }
    }

    customElements.define('footer-panel', FooterPanel);
  }
})();
